export function ProgressBar({ step, steps }) {
  return (
    <ol className="flex items-center w-full text-xs sm:text-sm font-medium text-center text-slate-500">
      {steps.map((s, i) => {
        const active = i === step;
        const done = i < step;
        return (
          <li key={s} className={`flex items-center ${i < steps.length - 1 ? 'w-full' : ''}`}>
            <span className={`flex items-center justify-center w-7 h-7 rounded-full shrink-0
              ${done ? 'bg-brand-700 text-white' : active ? 'bg-brand-100 text-brand-800 ring-2 ring-brand-500' : 'bg-slate-200 text-slate-500'}`}>
              {done ? '✓' : i + 1}
            </span>
            <span className={`hidden sm:inline ms-2 ${active ? 'text-brand-800' : ''}`}>{s}</span>
            {i < steps.length - 1 && (
              <span className="flex-1 h-px mx-2 sm:mx-4 bg-slate-200" />
            )}
          </li>
        );
      })}
    </ol>
  );
}
